import { render, staticRenderFns } from "./iframeindex.vue?vue&type=template&id=bafb949e&scoped=true&"
import script from "./iframeindex.vue?vue&type=script&lang=js&"
export * from "./iframeindex.vue?vue&type=script&lang=js&"
import style0 from "./iframeindex.vue?vue&type=style&index=0&id=bafb949e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb949e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafb949e')) {
      api.createRecord('bafb949e', component.options)
    } else {
      api.reload('bafb949e', component.options)
    }
    module.hot.accept("./iframeindex.vue?vue&type=template&id=bafb949e&scoped=true&", function () {
      api.rerender('bafb949e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/iframeindex.vue"
export default component.exports